<template>
    <div class="container my-8">
        <div class="flex items-start h-12 mb-8 border-b border-grey-700">
            <button
                class="search-tab"
                :class="{ 'search-tab-active': selectedIndex === productsIndex }"
                @click="selectedIndex = productsIndex"
            >
                Listings
            </button>

            <button
                class="search-tab"
                :class="{ 'search-tab-active': selectedIndex === pagesIndex }"
                @click="selectedIndex = pagesIndex"
            >
                Pages
            </button>
        </div>

        <Listings v-if="selectedIndex === productsIndex" />
        <Pages v-if="selectedIndex === pagesIndex" />
    </div>
</template>

<script>
import Listings from '@/Listings.vue';
import Pages from '@/Pages.vue';

export default {
    components: {
        Listings,
        Pages
    },

    data() {
        return {
            selectedIndex: `products_${this.$root.hub}`,
            query: ''
        };
    },

    computed: {
        productsIndex() {
            return `products_${this.$root.hub}`;
        },

        pagesIndex() {
            return `pages_${this.$root.hub}`;
        }
    }
};
</script>

<style scoped>
.subitem-wrapper:before,
.subitem-wrapper:after {
    margin: auto;
    content: '';
}
</style>
